import React from 'react';
import { useField } from 'react-final-form';

import { type FWorkflowTriggerFragment } from '@dashboard/generated/wp/platform';

import HttpPostTriggerCard from './HttpPostTriggerCard';
import WorkflowKeyTriggerCard from './WorkflowKeyTriggerCard';

type Props = {
  name: string;
};
export default function SingleTriggerSection({ name }: Props) {
  const { value } = useField<FWorkflowTriggerFragment>(name).input;

  if (value.workflowKey) {
    return <WorkflowKeyTriggerCard name={name} />;
  }
  if (value.httpPost) {
    return <HttpPostTriggerCard name={name} />;
  }
  return null;
}
